import { ChevronsRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useConsoleBreadcrumb } from '@/hooks/useConsoleBreadcrumb'

interface ConsoleBreadcrumbProps {
  /** 移动端仅显示当前页标题 */
  mobileTitleOnly?: boolean
}

export default function ConsoleBreadcrumb({ mobileTitleOnly = false }: ConsoleBreadcrumbProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const currentPage = useConsoleBreadcrumb()

  if (mobileTitleOnly) {
    return (
      <span className="md:hidden text-[var(--console-text)] font-semibold text-[13px] truncate">
        {currentPage}
      </span>
    )
  }

  return (
    <div className="hidden md:flex items-center gap-1.5 min-w-0 text-[13px]">
      <button
        type="button"
        onClick={() => navigate('/console')}
        className="text-[var(--console-text-muted)] hover:text-[var(--brand-primary)] transition-colors flex-shrink-0"
      >
        {t('layout.console')}
      </button>
      <ChevronsRight size={12} className="text-[var(--console-text-subtle)] flex-shrink-0" aria-hidden />
      <span className="text-[var(--console-text)] font-semibold truncate">{currentPage}</span>
    </div>
  )
}
